export class ScoreStream {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "ScoreStream";
    this.scene = "Score Update";
    this.data = [];
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    this.data = [];

    this.data.push({
      name: "Home Team Name",
      value: {
        text: options?.game?.home_team?.name,
      },
    });
    this.data.push({
      name: "Home Team Short Name",
      value: {
        text: options?.game?.home_team?.short_name,
      },
    });
    this.data.push({
      name: "Home Team Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.home_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.third_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Name",
      value: {
        text: options?.game?.away_team?.name,
      },
    });
    this.data.push({
      name: "Away Team Short Name",
      value: {
        text: options?.game?.away_team?.short_name,
      },
    });
    this.data.push({
      name: "Away Team Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.away_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.third_badge || "",
      },
    });

    let home_Kit = options.homeKit;
    let away_Kit = options.awayKit;

    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour: options.game?.home_team?.variables?.[home_Kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour: options.game?.away_team?.variables?.[away_Kit + "_kit_bg"] || "",
      },
    });

    let home_score = options.homeScore;
    let away_score = options.awayScore;
    this.data.push({
      name: "Home Score",
      value: {
        text: home_score || "0",
      },
    });
    this.data.push({
      name: "Away Score",
      value: {
        text: away_score || "0",
      },
    });

    this.data.push({
      name: "Period",
      value: {
        text: options.subtitle,
      },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
